import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronLargeTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-large-top, chev top, up"} maskId="square-filled-radius-0-stroke-1-IconChevronLargeTop"><path fillRule="evenodd" clipRule="evenodd" d="M12 8.93457L22.1754 14.29L21.7096 15.1749L12 10.0646L2.29045 15.1749L1.82471 14.29L12 8.93457Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronLargeTop;
